import { render, staticRenderFns } from "./UserSubscriptionView.vue?vue&type=template&id=bde52d9a"
import script from "./UserSubscriptionView.vue?vue&type=script&lang=js"
export * from "./UserSubscriptionView.vue?vue&type=script&lang=js"
import style0 from "./UserSubscriptionView.vue?vue&type=style&index=0&id=bde52d9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports